import React, {Fragment, memo, useEffect, useRef, useState} from "react";
import {createConnection} from "../services/fetch";
import {getStroke} from "perfect-freehand";
import Opts from "../services/opts";
import {useParams, useSearchParams} from "react-router-dom";
import {Line, LinesC} from "../services/lines";
import {convertMedia} from '@remotion/webcodecs';
import {MyS3} from "../services/context";
import {Shaders} from "../services/shaders";
import Player from "../services/player";
import fixWebmDuration from 'webm-duration-fix';
import Date from "moment/moment";
import {useDom} from "../context/dom";
import {DialogP} from "./dialog";
import {ZoomInOutlined} from "@mui/icons-material";


/***

 replaying existing movies



 */
const getSvgPathFromStroke = (stroke) => {
    if (!stroke.length) {
        return '';
    }

    const d = stroke.reduce(
        (acc, [x0, y0], i, arr) => {
            const [x1, y1] = arr[(i + 1) % arr.length];
            acc.push(x0, y0, (x0 + x1) / 2, (y0 + y1) / 2);
            return acc;
        },
        ['M', ...stroke[0], 'Q']
    );

    d.push('Z');
    return d.join(' ');
}
const Pa = (o) => {
    const [d, setD] = useState('');
    // const [str, setStr] = useState(null);
    const t = o.line;


    if (t && t.dots) {

//t.type='pen';
        const line = JSON.parse(t.dots.replace(/}/g, ']').replace(/{/g, '['));
        const opts = new Opts(t.width ? t.width : 4, t.type);
        // setD(getSvgPathFromStroke(getStroke(line, opts)));

        // setTimeout(() => o.in(o.tm + 1), 400);
    }


    return (
        <>
            {d && (
                <path d={d} fill={t.color}/>

            )
            }
        </>
    )
}


export default function Sket({story_id, page}) {
    const dom = useDom()
    const paper = dom.paper;
    const kit = dom.ck;
    const ck = dom.ck;
    const [isAwake, setIsAwake] = useState(false);
    const wakeLockRef = useRef(null);

    const requestWakeLock = async () => {
        try {
            if ('wakeLock' in navigator) {
                wakeLockRef.current = await navigator.wakeLock.request('screen');
                setIsAwake(true);

                // Listen for the OS releasing the lock (e.g., low battery or tab minimized)
                wakeLockRef.current.addEventListener('release', () => {
                    setIsAwake(false);
                    console.log('Screen Wake Lock released');
                });
            } else {
                console.warn('Wake Lock API not supported in this browser.');
            }
        } catch (err) {
            console.error(`${err.name}, ${err.message}`);
        }
    };

    const releaseWakeLock = async () => {
        if (wakeLockRef.current !== null) {
            await wakeLockRef.current.release();
            wakeLockRef.current = null;
        }
    };
    useEffect(() => {
        return () => {
            releaseWakeLock();
        };
    }, []);
    const createRandomString = (length) => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }
    //https://morning-dawn-3bf1.facereplays.workers.dev/my-file.txt')

    const fub = (e) => {

        brush.current = e.brush ? e.brush : brush.current;
        color.current = e.color ? new paper.Color(e.color) : color.current;
        sizeN.current = e.size ? e.size : sizeN.current;
        localStorage.setItem('brush', brush.current);
        localStorage.setItem('size', sizeN.current);
        e.color && localStorage.setItem('color', e.color);
    }
    const dialog = useRef(null);
    const player = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const caseUse = searchParams.get('caseUse');
    const debug = searchParams.get('debug');
    const test = searchParams.get('test');
    const htmlDivElement = useRef(null);
    const htmlCanvasElement = useRef(null);
    const chunks = [];
    const colors = ['#000000', '#ff5252', '#ffbc00', '#00c853', '#00b0ff', '#d500f9', '#8d6e63', '#fafafa', '#a52714', '#ee8100', '#558b2f', '#01579b', '#8e24aa', '#4e342e', '#90a4ae', '#ff4081', '#ff6e40', '#aeea00', '#304ffe', '#7c4dff', '#1de9b6', '#cfd8dc', '#f8bbd0', '#ffccbc', '#f0f4c3', '#9fa8da',
        '#d1c4e9', '#b2dfdb'];
    const media_recorder = useRef(null);
    let sor = '';
    const sca = 1;
    const read = async (a) => {
//const so=
        sor += String.fromCharCode.apply(null, a);
    }
    const data = useParams();

    const id = (data.id && data.id.match(/^([\d]+)$/)) ? data.id : story_id ? story_id : 500;

    const draw = useRef(false);


    const [lns, setLns] = useState([]);
    let speed = useRef(12);
    const objN = useRef(null);
    const surfRef = useRef(null);
    const suRef = useRef(null);
    const sujet = useRef(null);
    const [inte, setInte] = useState(0);
    const [dia, setDia] = useState(false);
    const [drawS, setDrawS] = useState(false);
    const lineR = useRef(0);
    const lineNArray = useRef([]);
    let wi = window.innerWidth * .9;
    let hi = window.innerHeight * .9;
    let hh = 0;
    let ww = 0;
    let widthR = 0;
    let surface;
    let su;
    let tm = 0;
    let totm = 0;
    let rrb;
    let bgImage;
    let bgImageFinal;
    const ran = Math.random();
    let shader1;
    let paperB;
    let rootElement;

    let coef;
    const linesC = new LinesC();
    let line = null;

    let paint;
    let paintB;
    let paintA;
    let paintC;
    let surfV;
    let suV;
    let shdFf;
    let shdSFlo;
    let shdFinal;
    let shdS;
    let shdSH;
    let wetmap;
    const matr = [
        1, 0, 0, 0,
        0, 1, 0, 0,
        0, 0, 1, 0,
        0, 0, 0, 1];

    const fetchFont = async (ck, hh) => {
        let robotoData = await fetch(
            require('../static/NotoSans-Bold.ttf')
        ).then((resp) => resp.arrayBuffer());


        const fontMgr = ck.FontMgr.FromData([robotoData]);
        const speedUp = (s) => {
            speed.current += s;
        }
        const paraStyle = new ck.ParagraphStyle({
            textStyle: {
                color: ck.Color(0, 0, 0, .4),
                fontFamilies: ["Roboto"],
                fontSize: hh > 600 ? 12 : 10
            },
            strutStyle: {
                strutEnabled: true,
                fontFamilies: ["Roboto"],
                fontSize: hh > 600 ? 12 : 10,
                heightMultiplier: 1.3,
                forceStrutHeight: true
            },
            textAlign: ck.TextAlign.Center,
            maxLines: 7,

            ellipsis: "..."
        });

        return {fontMgr, paraStyle};
    }


    const on_mr_stop = async (chunks) => {

        // Gather chunks of video data into a blob and create an object URL

        const blob = new Blob(chunks, {type: "video/webm;codecs=h264"});
        //const blob = new Blob(chunks, {type: "video/mp4;codecs=vp9"});
        const fixBlob = await fixWebmDuration(blob);

        await convertMedia({
            src: fixBlob,
            container: 'mp4',
            videoCodec: 'h264',
            audioCodec: 'aac',
        }).then(f => {
            const blobF = f.save().then(
                v => {

                    const path = 'mhNv_h' + sujet.current.id.toString() + '.mp4';


                    const myFile = new File([v], path, {
                        type: fixBlob.type,
                    })
                    if (window.location.href.match(/local/)) {
                        fetch('https://morning-dawn-3bf1.facereplays.workers.dev/' + path, {
                            method: "POST",
                            headers: {'Content-Type': "video/mp4"},
                            body: myFile
                        }).then((response) => response.json()).then(a => {
                            a.res && a.res == 1 && createConnection().update('sujet', id, {video: 'https://vids.memigration.info/' + path});
                        });
                        /*   const recording_url = URL.createObjectURL(v);
                           // Attach the object URL to an <a> element, setting the download file name
                           const a = document.createElement('a');
                           a.style = "display: none;";
                           a.href = recording_url;
                           a.download = 'f'+sujet.current.id+".webm";
                           document.body.appendChild(a);
                           // Trigger the file download
                           a.click();
                           */

                    } else {
                        const tt = MyS3().thumb(path, myFile, "video/mp4", sujet.current.id);
                    }
                })


        })


// The video get from the MediaRecorder as a Blob

        /*
        await convertMedia({
          src: blob,
          container: 'mp4',
          videoCodec: 'vp9',
          onVideoTrack: ({track}) => {
         console.log(track)
          }
        }).then(a=>console.log(a.finalState));





       console.log(webmToMp4(myFile));  */

        /*
            const recording_url = URL.createObjectURL(fixBlob);
            // Attach the object URL to an <a> element, setting the download file name
            const a = document.createElement('a');
            a.style = "display: none;";
            a.href = recording_url;
            a.download = 'f'+sujet.current.id+".webm";
            document.body.appendChild(a);
            // Trigger the file download
        a.click();
         /*  /*

             setTimeout(() => {
               // Clean up - see https://stackoverflow.com/a/48968694 for why it is in a timeout
               URL.revokeObjectURL(recording_url);
               document.body.removeChild(a);
             }, 0);

           */

    }
    let paragraph;

    const lines = [];
    const linesExtra = [];
    const getObj = (ob, obj, i, ar = []) => {

        const exF = startLine.current ? '&filter=id,le,' + startLine.current : '';
        createConnection().getNew('strokes', 'order=start,asc&join=point&filter=objet,eq,' + obj[ob].id + exF + "&page=" + i + ',20').then(a => { //filter=id,lt,1366454&
            const recs = a.records.map((u, i) => {
                u.n = i;
                // u.color =  u.color.match(/^([0-9]+)$/) ? colors[Number[u.color ]] : u.color;
                if (u.point) {
                    u.line = u.point.filter(a => !a.pu && a).sort((a, b) => a.id - b.id).map(g => {
                        g = JSON.parse(g.po);
                        return {x: g[0], y: g[1], pressure: g[2]}
                    })


                } else {

                    u.line = u.line != '[]' ? JSON.parse(u.line) : JSON.parse(u.dots.replace(/{/g, '[').replace(/}/g, ']'));

                }

                let p;
                u.ran = Math.random()
                u.lineD = u.line.filter(h => {
                    let ret = false;
                    if (!p) ret = true; else {
                        if (h.x) {
                            if (p.x != h.x && p.y != h.y) ret = true;


                        } else {
                            if (p[0] != h[0] && p[1] != h[1]) ret = true;


                        }
                    }
                    p = h;

                    return ret ? h : null;

                }).map(h => {
                 // console.log(u.type=='Pen' && ((h.pressure+1)+','+u.width).toString())
                    return !h.x ? {
                        x: (h[0] + size[2]) * coef,
                        y: (h[1] + size[3]) * coef,
                        pressure: h[2] * sca
                    } : {x: h.x * coef + size[2] * coef, y: h.y * coef + size[3] * coef, pressure: u.type=='Pen' ? (h.pressure+1)*.5 : h.pressure * sca};

                });

//u.opts=new Opts(u.size ? u.size:1,u.type);


                //   const opts = new Opts(u.width ? 0.4 * u.width : 0.2, u.type,obj[ob].pointer);
                //  const opts = new Opts(t.width ? t.width : 4, t.type);

                // u.opts = opts;
                u.opts = u.type == 'Pen' ? {
                    size: u.width ? u.width*2.5 : 0.4,
                    thinning: -0.2,
                    simulatePressure: true
                } : u.opts = u.type == 'Highlighter' ? {

 smoothing: 0,
                    thinning: 0,
                    streamline: 0.3,
                    easing: (t) => t,
                    start: {
                        taper: 0,
                        cap: false,
                    },
                    end: {
                        taper: 0,
                        cap: false,
                    },

                    size: u.width ? u.width : 0.2,

                    simulatePressure: false
                } : {
                    size: u.width ? 0.02 * u.width : 0.2,
                    thinning: 1,
                    simulatePressure: false
                }
                //  u.opts =new Opts(u.width ? 0.4 * u.width : 0.2, u.type,obj[ob].pointer ? obj[ob].pointer : false);
                //console.log(u.type,u.opts);
                if (!u.delta || u.delta > 1000) {
                    const ln = new paper.Path(u.lineD.map(a => [a.x, a.y]));
                    u.delta = ln.length;
                }
                let col;
                u.d = getSvgPathFromStroke(getStroke(u.lineD, u.opts));
                if (u.color.match('#')) {

                    const co = new paper.Color(u.color);

                    u.color = new ck.Color4f(co.red, co.green, co.blue, u.type == 'Pen' ? 1 : 0.8);
                    u.col = [co.red, co.green, co.blue, u.type == 'Pen' ? 1 : 0.8];
                } else {
                    u.color = u.color.match(' ') ? u.color.replace(/ /g, '') : u.color

                    col = u.color.match(/([\d|,|\.]+)/) ? u.color.match(/([\d|,|\.]+)/)[0].split(',') : [0, 0, 0, 1];


                    col.length == 3 && col.push(0.8);
                    u.color = new ck.Color(col[0], col[1], col[2], col[3]);

                    const colC = Math.max(col[0], col[1], col[2]) > Math.min(col[0], col[1], col[2]) * 1.2 ? u.type == 'Highlighter' ? .2 : 0.8 : 1;
                    u.col = col.map((c, i) => i < 3 ? Number(c) / 255 : Number(c) * colC);
                }

                const paint2 = new ck.Paint();
                paint2.setColor(u.color);
                paint2.setStyle(ck.PaintStyle.Fill);
                paint2.setAntiAlias(true);

                u.paint = paint2;
                lines.push(u);


                //if (u.id == 10729) console.log(u.d, u.lineD, u.line);
                return u;

            });
            if (i == 1 && ob == 0) {
                lineR.current = a.results
                const u = recs[0];
                u.alpha = u.type == 'Highlighter' ? .2 : 1;


                line = new Line(u.width ? u.width : 1, u.color, u.alpha ? u.alpha : 1, u.opts, 0, u.id, u.type);
                // console.log(line);

            }
            //console.log(as);
            a.records.length == 20 && i * 20 < a.results ? getObj(ob, obj, i + 1, []) : ob + 1 < sujet.current.objet.length ? getObj(ob + 1, obj, 1, []) : bb(lines);
        });
    }
    const bb = (l) => {
        lineR.current = lineR.current + linesExtra.length;
        linesExtra.map((s, i) => {
            s.start = lines.length;

            objN.current = s.objet
            lines.push(s)

        })
        // console.log(lines.map(y=>y.start))
    }
    let oldTan;
    let lastFrame = Date.now();
    const played = useRef(false);
    const extraLines = [];
    let shh;
    const str = () => {
        media_recorder.current.state === 'inactive' && media_recorder.current.start(1000);
    }
    const drawLastFrame = (sum) => {
        if (shh && lastFrame + 20000 > Date.now()) {
            const ko = Date.now() - lastFrame;

            const matr1 = [
                1 + ko / 400000, 0, 0, -ko / 800000 * ww,
                0, 1 + ko / 400000, 0, -ko / 800000 * hh,
                0, 0, 1, 0,
                0, 0, 0, 1];
            const shn = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [shh, paperB], matr1);
            //console.log('s');
            paintC.setShader(shn);
            suRef.current.drawRRect(rrb, paintC);
            paragraph && paragraph.layout(300);
            const fo = hh > 600 ? 8 : 7;
            paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);
            surfRef.current.requestAnimationFrame(drawLastFrame)
        } else {

            media_recorder.current.stop()
        }
    }
    const redraw = (i) => {

        line = lines[i];
        surfRef.current.requestAnimationFrame(() => {
            suRef.current.clear();

            //
            drl(10000000000000, true)
            i < 15 && redraw(i + 1);

        })


    }
    const clear = () => {

        surfRef.current.requestAnimationFrame(() => {
            suRef.current.clear();
            const im1 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);

            bgImage = im1.makeShaderOptions(
                ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                ck.TileMode.Repeat,
                ck.FilterMode.Linear,
                ck.MipmapMode.Nearest,
                ck.Matrix.identity()
            );
            const shn = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [bgImage, paperB], matr);
            im1.delete();
            paintC.setShader(shn);
            suRef.current.drawRRect(rrb, paintC);
            paragraph && paragraph.layout(300);
            const fo = hh > 600 ? 8 : 7;
            paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);

        })

    }
    const drawFrameN = (sum) => {

        /*


        making line on empty transparent canvas
         */
        const line = lineN.current;
        let bounds;
        if (!line || !line.points) return;
        const dts = line.points.filter(p => p.x > 0 && p.x < ww && p.y > 0 && p.y < hh);
        const ln = new paper.Path(dts.map(a => [a.x, a.y]));
        bounds = ln.strokeBounds;

        let firstPath;
        if (line.brush == 'flo') {


            dts.map((a, i) => {

                const pa = new ck.Paint();
                pa.setStyle(ck.PaintStyle.Fill);
                const po = [i % ww, Math.floor(i / ww)];

                pa.setColor(new ck.Color4f(a.x / ww, a.y / hh, a.pressure, 1)); // Black color
                suRef.current.drawRect4f(po[0], po[1], po[0] + 1, po[1] + 2, pa);

            });

        } else {

            const d = getSvgPathFromStroke(getStroke(dts, line.opts));

            firstPath = ck.Path.MakeFromSVGString(d);
            // paint= new ck.Paint();

            suRef.current.drawPath(firstPath, paint);
            firstPath.delete();
        }

//firstPath.stroke({width:1});

        /***
         line added


         extraLines.map(s => {
         //  suRef.current.drawCircle(s[2], s[3], 1, paint);


         });

         generating layer from line
         */



        const im2 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
        shader1 = im2.makeShaderOptions(
            ck.TileMode.Repeat,  // Tile the image in both X and Y directions
            ck.TileMode.Repeat,
            ck.FilterMode.Linear,
            ck.MipmapMode.Nearest,
            ck.Matrix.identity()
        );
        /***
         shader1 contains line

         */
        if (step > 1) {
            suRef.current.clear();
            im2.delete();


            if (line.brush == 'flo') {
                const rcol = line.col

                const art = rcol.concat(ww, hh, line.ran, bounds.top, bounds.bottom + line.size * 2, 3, dts.length, Date.now() - line.startT, line.size);


                const ara = new Float32Array(
                    art
                );

                shh = shdSFlo.makeShaderWithChildren(ara, [shader1, bgImage, paperB], matr);

            } else if (line.brush == 'Highlighter') {
                shh = shdS.makeShaderWithChildren(new Float32Array(line.col.concat(ww, hh, line.alpha,
                    0,
                    hh,
                    3)), [shader1, bgImage, paperB], matr);

            } else {
                shh = shdS.makeShaderWithChildren(new Float32Array(line.col.concat(ww, hh, line.alpha,
                    bounds ? bounds.top : 0,
                    bounds ? bounds.bottom + line.width + 48 : hh,
                    3)), [shader1, bgImage, paperB], matr);

            }


            paintA.setShader(shh);

            suRef.current.drawRRect(rrb, paintA);


            if (step > 2) {
                console.log('step', step)
                if (shh) {
                    const shn = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [shh, paperB], matr);

                    paintC.setShader(shn);
                    suRef.current.drawRRect(rrb, paintC);
                    // paragraph && paragraph.layout(300);
                    // const fo = hh > 600 ? 8 : 7;
                    // paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);
                }
            }
            /***  **/
            /**/
        }

        /*   /   const im4 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
                  bgImageFinal = im4.makeShaderOptions(
                    ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                    ck.TileMode.Repeat,
                    ck.FilterMode.Linear,
                    ck.MipmapMode.Nearest,
                    ck.Matrix.identity()
                  );
                  im4.delete();
            suRef.current.clear();
                */

        draww.current && surfRef.current.requestAnimationFrame(drawFrameN)
    }
    const drl = (ttm, fast = true) => {


        let bounds;
        let l = 0;
        let br = false;
        shh = null;
        let done = 0;
        const linesC = lns.length > 0 ? lns : lines;

        const r = linesC.find(o => o.id == line.id);
//  suRef.current.drawRRect(rrb, paintC);
//  suRef.current.drawRRect(rrb, paintC);
        // linesC.map((r, i) => {


        const dts = fast ? r.lineD : r.lineD.filter((s, y) => {

            return y / r.lineD.length < (ttm - totm) / r.delta ? true : false
        });
       // if(){}else{}

            const ln =new paper.Path(dts.map(a => [a.x, a.y]))



        ln.strokeWidth=line.width;
        ln.strokeCap = 'square';
        ln.strokeColor=new paper.Color(line.color)
        //ln.fullySelected=true;
        ln.strokeJoin = 'bevel';
       // var raster = ln.rasterize({insert:false});
        //console.log(raster)

        bounds = ln.strokeBounds;

        if (dts.length > 2 && debug) {
            const segs = dts.map(f => new paper.Segment(f.x, f.y));

            const lln = paper.project.activeLayer.children[0]
            lln.removeSegments();
            lln.segments = segs;
            lln.strokeColor = new paper.Color(1, 0, 0, 0.0);
            lln.fullySelected = true;
            /*  const tan = ln.getTangentAt(ln.length);
           /*  if (dts.length > 3) {
                 const rp = dts[dts.length - 1];
                 Math.abs(tan.dot(oldTan)) < 0.6 && extraLines.push([rp.x, rp.y, rp.x + tan.x * 3, rp.y + tan.y * 3]);

             }
             oldTan = tan; */
        }


        let firstPath;
        if (r.type == 'flo') {


            dts.map((a, i) => {

                const pa = new ck.Paint();
                pa.setStyle(ck.PaintStyle.Fill);
                const po = [i % ww, Math.floor(i / ww)];

                pa.setColor(new ck.Color4f(a.x / ww, a.y / hh, a.pressure, 1)); // Black color
                suRef.current.drawRect4f(po[0], po[1], po[0] + 1, po[1] + 2, pa);
                pa.delete();
            });

        } else if (r.type == 'Highlighter') {

            if (dts.length >1){
            const d = ln.pathData;

            firstPath = ck.Path.MakeFromSVGString(d);
paintLine.setStrokeWidth(line.size*coef);

            suRef.current.drawPath(firstPath, paintLine);
                firstPath.delete();
        } else {
                const poi=dts[0]
                console.log(poi)
                const wid=line.size*coef*.5
                firstPath = ck.LTRBRect(poi.x-wid,poi.y-wid, poi.x+wid,poi.y+wid)
                suRef.current.drawRect(firstPath, paint);
               // firstPath.delete();
            }

        } else {

            const d = getSvgPathFromStroke(getStroke(dts, r.opts));

            firstPath = ck.Path.MakeFromSVGString(d);
            suRef.current.drawPath(firstPath, paint);
            firstPath.delete();
        }

//firstPath.stroke({width:1});

        /***
         line added


         extraLines.map(s => {
         //  suRef.current.drawCircle(s[2], s[3], 1, paint);


         });

         */



        const im2 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
        shader1 = im2.makeShaderOptions(
            ck.TileMode.Repeat,  // Tile the image in both X and Y directions
            ck.TileMode.Repeat,
            ck.FilterMode.Linear,
            ck.MipmapMode.Nearest,
            ck.Matrix.identity()
        );
        /***
         shader1 contains line

         */
        im2.delete();
        if (step > 1) {
            suRef.current.clear();

            if (r.type == 'flo') {

                /*
                [0.5607843137254902 ww, 0.2196078431372549 hh, 0.2196078431372549 r.ran, 0.6400000000000001, 675, 1200, undefined, 1014.7632678780776, NaN, 3, 76, NaN, undefined]
                 */
                const art = r.col.concat(ww, hh, r.ran, bounds.top, bounds.bottom + r.width * 2, 3, dts.length, Date.now() - r.start, r.width);


                const ara = new Float32Array(
                    art
                );
                console.log(art, 'ff')
                shh = shdSFlo.makeShaderWithChildren(ara, [shader1, bgImage, paperB], matr);

            } else if (r.type == 'Highlighter') {

                shh = shdSH.makeShaderWithChildren(new Float32Array(r.col.concat(ww, hh, r.alpha,
                    0,
                    hh,
                    3)), [shader1, bgImage, paperB], matr);


            } else {
                shh = shdS.makeShaderWithChildren(new Float32Array(r.col.concat(ww, hh, .8,
                    bounds ? bounds.top : 0,
                    bounds ? bounds.bottom + 8 : hh,
                    3)), [shader1, bgImage, paperB], matr);

            }


            paintA.setShader(shh);

            suRef.current.drawRRect(rrb, paintA);
        }
        /*   /   const im4 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
                  bgImageFinal = im4.makeShaderOptions(
                    ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                    ck.TileMode.Repeat,
                    ck.FilterMode.Linear,
                    ck.MipmapMode.Nearest,
                    ck.Matrix.identity()
                  );
                  im4.delete();
            suRef.current.clear();
                */
        r.done = ttm - totm > r.delta ? 1 : 0;
        if (debug) log.current.innerText = 'Drawing line: #' + r.id + ' points drawn:' + r.lineD.length;
        done = r.start + 1 == lineR.current && r.objet == objN.current ? r.done : 0;

        if (ttm - totm > r.delta || fast) {
            //
            if (r.start < lines.length - 1) {

                br = true;
                const u = lines[r.start + 1];

                line = new Line(u.width ? u.width : 1, u.color, u.alpha, u.opts, 0, u.id, u.type);
                r.n = r.start;


                // extraLines.splice(0, extraLines.length);
                l = 1;


                const im3 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
                // suRef.current.clear();
                /***

                 got a background image with top layer


                 **/
                bgImage = im3.makeShaderOptions(
                    ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                    ck.TileMode.Repeat,
                    ck.FilterMode.Linear,
                    ck.MipmapMode.Nearest,
                    ck.Matrix.identity()
                );

                //
//paintC.setShader(bgImage);
                //im1.delete();
                im3.delete();
                suRef.current.clear();
                totm = ttm;


            } else {


            }

        } else {

            //console.log('dd');
        }


        // });
        //su.clear();
        if (step > 2) {
            if (shh) {

                const shn = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [shh, paperB], matr);

                paintC.setShader(shn);
                suRef.current.drawRRect(rrb, paintC);
                // paragraph && paragraph.layout(300);
                //   const fo = hh > 600 ? 8 : 7;
                // paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);
            }
        }

        return {done: done, br: br};

    }
    const drawFrame = (sum) => {


        let done = 0;
        let br = false;

        if (line) {

            const ddr = drl(tm, false)
            //console.log(kit.memory.buffer.byteLength)
            done = ddr.done;
            br = ddr.br;
        }


        if (lines.length > 0) tm += speed.current;
        if (done == 0) {


            (media_recorder.current && media_recorder.current.state === 'inactive') && setTimeout(() => {

                media_recorder.current.ondataavailable = (evt) => {
                    chunks.push(evt.data);
                };
                str();
            }, 100);
            if (!draw.current) {


                !br ? surfRef.current.requestAnimationFrame(drawFrame) : setTimeout(() => {
                    surfRef.current.requestAnimationFrame(drawFrame)
                }, 100);
                /*  */

            }
            /*

            all lines done
             */
            // console.log(media_recorder.current.state,'str');
        } else {

            if (!sujet.current.video && media_recorder.current) {

                lastFrame = Date.now();
                surfRef.current.requestAnimationFrame(drawLastFrame);
            }


            if (!sujet.current.thumb) {

                const image = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
                const pngData = image.encodeToBytes();
                const path = createRandomString(5) + sujet.current.id.toString() + '.png';
                const blob = new Blob([pngData], {type: 'image/png'});

                const myFile = new File([blob], path, {
                    type: blob.type,
                });
                if (window.location.href.match(/local/)) {
                    fetch('https://morning-dawn-3bf1.facereplays.workers.dev/s' + path, {
                        method: "POST",
                        headers: {'Content-Type': 'image/png'},
                        body: myFile
                    }).then((response) => response.json()).then(a => {
                        if (a.res && a.res == 1) {
                            createConnection().update('sujet', id, {thumb: 'https://vids.memigration.info/s' + path});
                            sujet.current.thumb = 'https://vids.memigration.info/s' + path;

                        }
                    });
                } else {
                    const tt = MyS3().thumb(path, myFile, 'image/png', sujet.current.id);

                }
            }
            played.current = true;
            //  setLns(lines);
            //  setDone(true);
        }

//if(tm<209)
//setTtm(Date.now());
    }

    /***

     end draw frame


     */


    let paintF;
    let paintLine;
    let hhR;
    let font;
    let size;


   // const replay = useRef(null);
   const  replay = () => {

        played.current = false;
        /*
         window.location.reload();   setDone(false);

            lns.map(a => {a.done = false; lines.push(a);});

            //console.log(lines);
            //lines.push(lns);

            console.log(lines);
            su = surf.getCanvas();
            surface = surf;

            ck=ckit;
            upl(false);
        */
        lines.map(a => {
            a.done = false
        });
        tm = 0;
        line = lines[0];
        //    console.log(lines,paint,ck,surface);
        suRef.current.clear();
        const im1 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);

        bgImage = im1.makeShaderOptions(
            ck.TileMode.Repeat,  // Tile the image in both X and Y directions
            ck.TileMode.Repeat,
            ck.FilterMode.Linear,
            ck.MipmapMode.Nearest,
            ck.Matrix.identity()
        );
//paintB.setShader(shader1);
        im1.delete();
        suRef.current.clear();
        surfRef.current.requestAnimationFrame(drawFrame);


    }

    const upl = (a, ww, hh) => {

        paintF = new ck.Paint();
        paintF.setColor(ck.Color(255, 0, 0, 1)); // Black color
        paintF.setAntiAlias(true);
        paintF.setStyle(ck.PaintStyle.Stroke);
        paintF.setStrokeWidth(4);

        font = new ck.Font(null, 16);
        // surfV = ck.MakeCanvasSurface(new OffscreenCanvas(ww, hh));
        // suV = surfV.getCanvas();
        surface = ck.MakeCanvasSurface('foo');
        surfRef.current = surface;
        //  !surf && setSurf(surface);
        suRef.current = surfRef.current.getCanvas();
        const bpaint = new ck.Paint();
        bpaint.setColor(ck.Color4f(228 / 225, 221 / 225, 198 / 225, 1));
        bpaint.setStyle(ck.PaintStyle.Fill);
        paint = new ck.Paint();
        //  console.log('paint',paint);
        paint.setColor(ck.Color4f(0.12, .12, .1, 1));
        paint.setStyle(ck.PaintStyle.Fill);
        paint.setAntiAlias(true);
        paintLine = new ck.Paint();
        //  console.log('paint',paint);
        paintLine.setColor(ck.Color4f(250, 250, 250, 1));
        paintLine.setStyle(ck.PaintStyle.Stroke);
        paintLine.setStrokeWidth(2);
        paintLine.setStrokeCap(ck.StrokeCap.Square);
        paintLine.setStrokeJoin(ck.StrokeJoin.Bevel);
        paintLine.setAntiAlias(true);


        paintB = new ck.Paint();
        //paintB.setColor(ck.Color4f(.0,.0,.0,.0));
        paintB.setStyle(ck.PaintStyle.Fill);
        paintB.setAntiAlias(true);
        paintA = new ck.Paint();
        paintA.setStyle(ck.PaintStyle.Fill);
        paintA.setAntiAlias(true);
        paintC = new ck.Paint();

        paintC.setStyle(ck.PaintStyle.Fill);
        paintC.setAntiAlias(true);

        rrb = ck.LTRBRect(0, 0, ww, hh);
        //su.drawRRect(rrb, bpaint);




        fetchFont(ck, hh).then(f => {
            createConnection().getNew('story/' + a.story, 'join=user').then(g => {


                const builder = ck.ParagraphBuilder.Make(f.paraStyle, f.fontMgr);
                builder.addText(a.name + ' @ ' + g.name + '\nEsketchos.art©2026');

                paragraph = builder.build();


                const im1 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);

                bgImage = im1.makeShaderOptions(
                    ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                    ck.TileMode.Repeat,
                    ck.FilterMode.Linear,
                    ck.MipmapMode.Nearest,
                    ck.Matrix.identity()
                );
//paintB.setShader(shader1);
                im1.delete();

                fetch(require('../static/normal.jpg'))
                    .then((response) => response.arrayBuffer())
                    .then((buffer) => {
                        // console.log(new Uint8Array(buffer));
                        const bgg = ck.MakeImageFromEncoded(new Uint8Array(buffer));

                        paperB = bgg.makeShaderOptions(
                            ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                            ck.TileMode.Repeat,
                            ck.FilterMode.Linear,
                            ck.MipmapMode.Nearest,
                            ck.Matrix.identity()
                        );

                        paintA.setShader(paperB);
                        suRef.current.drawRRect(rrb, paintA);
                        const im2 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
                        const paperIm = ck.ImageFilter.MakeImage(im2, {filter: ck.FilterMode.Nearest});
                        const dispFilter = ck.ImageFilter.MakeDisplacementMap(ck.ColorChannel.Blue, ck.ColorChannel.Red, 10, paperIm, null);
                        paint.setImageFilter(dispFilter);
                        suRef.current.clear();

                        // paintB.setShader(bgImage);
                        //
                        im2.delete();
                        bgg.delete();

                        size.length > 2 ? widthR -= Math.min(0, Number(size[2])) : null;

                        const coMat = new paper.Matrix(coef, 0, 0, coef, 0, 0);

                        shdFinal = ck.RuntimeEffect.Make(Shaders().shdFinal_);
                        shdS = ck.RuntimeEffect.Make(Shaders().shdS);
                        shdSH = ck.RuntimeEffect.Make(Shaders().shdSH);

                        shdSFlo = ck.RuntimeEffect.Make(Shaders().shdSFlo);

                        const shn = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [bgImage, paperB], matr);

                        paintC.setShader(shn);
                        suRef.current.drawRRect(rrb, paintC);

                        paragraph && paragraph.layout(300);
                        const fo = hh > 600 ? 8 : 7;
                        paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);

                        /**/

                        // surfRef.current.requestAnimationFrame(drawFrame);
                        //  console.log(paragraph);
//surfRef.current.drawOnce(()=>{});



                        if (lns.length == 0 && test==1) {
                            Array(27).fill(Math.random()).map((a, i) => {

                                const pa = new ck.Paint();
                                pa.setStyle(ck.PaintStyle.Fill);
                                const po = [i % ww, Math.floor(i / ww)];

                                pa.setColor(new ck.Color4f(Math.random(), Math.random(), Math.random(), 1)); // Black color
                                suRef.current.drawRect4f(po[0], po[1], po[0] + 1, po[1] + 2, pa);
                                pa.delete();
                            });
                            const im2 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
                            shader1 = im2.makeShaderOptions(
                                ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                                ck.TileMode.Repeat,
                                ck.FilterMode.Linear,
                                ck.MipmapMode.Nearest,
                                ck.Matrix.identity()
                            );
                           suRef.current.clear();
                            im2.delete();
                            shdFf = ck.RuntimeEffect.Make(
                                `
   
               vec3 hash( vec3 p ) // replace this by something better
{
p = vec3( dot(p,vec3(127.1,311.7, 74.7)),
dot(p,vec3(269.5,183.3,246.1)),
dot(p,vec3(113.5,271.9,124.6)));
return -1.0 + 2.0*fract(sin(p)*43758.5453123);
}
float noise(vec3 p )
{
    vec3 i = floor( p );
    vec3 f = fract( p );
vec3 u = f*f*(3.0-2.0*f);
 return mix( mix( mix( dot( hash( i + vec3(0.0,0.0,0.0) ),
                           f - vec3(0.0,0.0,0.0) ),
  dot( hash( i + vec3(1.0,0.0,0.0) ), f - vec3(1.0,0.0,0.0) ), u.x),
  mix( dot( hash( i + vec3(0.0,1.0,0.0) ), f - vec3(0.0,1.0,0.0) ),
 dot( hash( i + vec3(1.0,1.0,0.0) ),
     f - vec3(1.0,1.0,0.0) ), u.x), u.y),
 mix( mix( dot( hash( i + vec3(0.0,0.0,1.0) ), f - vec3(0.0,0.0,1.0) ),
 dot( hash( i + vec3(1.0,0.0,1.0) ), f - vec3(1.0,0.0,1.0) ), u.x),
mix( dot( hash( i + vec3(0.0,1.0,1.0) ), f - vec3(0.0,1.0,1.0) ),
dot( hash( i + vec3(1.0,1.0,1.0) ),
    f - vec3(1.0,1.0,1.0) ), u.x), u.y), u.z );
}
float simpleNoise(vec2 uv,float freq) {
    return noise(vec3(freq * uv.xy, 1))*0.5 +0.5;
}
float hash(vec2 p) // Dave H
{
vec3 p3  = fract(vec3(p.xyx) * .1031);
    p3 += dot(p3, p3.yzx + 33.33);
    return fract((p3.x + p3.y) * p3.z);
}
float paper1 (vec2 U) {
    float h = .005*(sin(.6*U.x+.1*U.y)+sin(.7*U.y-.1*U.x));
    for (float x = -1.; x<=1.;x++)
    for (float y = -1.; y<=1.;y++){
        h += .15*.125*hash(U+vec2(x,y));
    }
    return h;
}

  uniform shader uImage;
  uniform shader bgImage;
uniform shader paper;
uniform float r;
uniform float g;
uniform float b;
uniform float a;
uniform float w;
uniform float h;
uniform float ff;
uniform float top;
uniform float bot;
uniform float brush;
uniform float leng;
uniform int tms;
uniform float size;
vec4 main(vec2 pos) {
vec2 uv = pos / vec2(w,h);
vec4 bg = bgImage.eval(pos);
vec4 pap1 = paper.eval(pos);
vec3 light=normalize(vec3(0.2+uv.x, uv.y/4, -0.01));
float cy=pos.y/h;
float dot=(dot(normalize(pap1.rgb),light)+1)/3.7;
vec3 bgCol=mix(vec3(245,245,235)/255,vec3(255-140*cy,255-140*cy,255-150*cy)/255,dot);

float hCoef =  sin(1-(pos.y-top)/(bot-top))*2;
//hCoef =  1;

vec4 sum0 = vec4(0.0);
vec4 sum3 = vec4(0.0);
float liu=1000000.0;
float wi=min(size*2,(size*(1+float(tms)/30)/10)); // + simpleNoise(uv,.04)*30;
float sel=0.0;
float lenn=0;
float len=0;
vec4 ln=uImage.eval(pos);
for (float i = 1; i <17.0; i++) {
sum0 = uImage.eval(vec2(i,1));
vec2 p0=vec2(sum0.r*w,sum0.g*h);
float rad=sum0.b*500;
vec2 v0 =pos - p0;
float d=length(v0)-rad;
if(length(v0)<rad){lenn=1-cos(d/rad);}else{lenn=0;}
//lenn = 1-cos(d/rad)*.2;
len=max(len,lenn);
}
liu=len;
sel=sel/lenn;
//
//float no = simpleNoise(vec2(0,sel),0.004)*100;
//wi=wi+sel*30;
//liu=pow((min(wi,liu))/wi,2);
//liu=liu<.3 ? 0 : pow(liu-0.3,1);
 float smallNoise = simpleNoise(uv+vec2(ff,-ff), 100.0);
   liu += 0.05 * smallNoise;

    // slightly deforming the shapes with low-frequency noise make them look less synthetic
    float largeNoiseFreq = 1.5;
    float largeNoise = simpleNoise(uv+vec2(ff,-ff), largeNoiseFreq);
    liu -= 0.9 * smoothstep(0.35, 1.0, largeNoise);
  
//////
   float wetNoiseFreq = 3.3 + sin(ff); // 1.0 .. 3.0
    float wetNoiseStrength = 0.2; // 0.1 .. 0.2
    float wetNoise = simpleNoise(uv, wetNoiseFreq);
    float wetNoiseStep = smoothstep(0.4, 0.55 + wetNoiseStrength, wetNoise);
    float wetness = clamp(wetNoiseStep , 0.0, 1.0);

////
   // strengthen the contrast at the edge (of the dry parts)
    float value;
    float valueSlim;
    if (liu < 0.02) {
        // no change in the center circle
        value = liu;
        valueSlim = 0.96;
    } else {
        const float aaDelta = 0.016; // add a small delta to reduce aliasing
        const float edgeWet = 0.84;
        float edgeDry = 0.04+0.04*hCoef;
        float edge1 = mix(edgeDry, edgeWet, wetness) + aaDelta;
        value =     smoothstep(edgeDry, edge1, liu);
        valueSlim = pow(1.0 - smoothstep(0.0, edge1, liu), 0.15);
    }
     
//liu=value;
 value = value + 0.5 * valueSlim;

    // add some more noise to give it a less uniform look
  float postNoise = simpleNoise(uv, 15.0);
    float ssStrength = 1.0;
    float postNoiseAmount = 1.0 - wetNoise;
    value = value + value *  postNoiseAmount * smoothstep(0.0, postNoise * ssStrength, value);

vec4 pap = paper.eval((pos+vec2(ff,1-ff))*2);
float papr=paper1(pos);
//return vec4(vec3(papr),1);

float noiseCol = simpleNoise(vec2(uv.x,uv.y*1.6+ff), 4);   
  float gradient =0.2 * (uv.x + uv.y);    
  vec3 distCol = mix(vec3(.9,.9,.8), vec3(noiseCol),vec3(.1,.1,.2));    
  vec3 colors1 = mix(distCol, vec3(1.0,1.0,1.0), value - papr * 2.0);
  vec3 colors2 = mix( clamp(colors1 , 0.0, 1.0), vec3(.8), bgCol);
 // return vec4(vec3(noiseCol),1);
return vec4(colors2,1);


//////
//papr=pap.r;
  //float noiseCol = noise(vec3(2.0 * uv.x, 2.0 * uv.y, 0.02));
    //float gradient = 0.5 * (uv.x + uv.y);
   // vec3 distCol = mix(vec3(r*1.0,g*1.0,b*1.0), vec3(abs(noiseCol)), vec3(r*1,g*1,b*1));
 //distCol=vec3(r,g,b)- vec3(abs(noiseCol))*max(0,1-hCoef);//;
   // vec3 colors = mix(distCol, vec3(1.0,1.0,1.0), value*1.2 - papr * 0.2);
//vec3 bgrgb=bg.r+bg.b+bg.g>0 && bg.r+bg.b+bg.g!=3 && colors.r+colors.b+colors.g>0 ? bg.rgb : vec3(1);
//return vec4(bg.rgb,1);
//return vec4(clamp(colors,0,1)*bg.rgb,1);
//return ln;
}
        
        
        `)
                            const art = Array(4).fill(1).concat(ww, hh, 0.8, 0, 30, 3, 50, Date.now(), 24);


                            const ara = new Float32Array(
                                art
                            );



                            const shn = shdFf.makeShaderWithChildren(ara, [shader1,bgImage, paperB], matr);

                            paintC.setShader(shn);
                         suRef.current.drawRRect(rrb, paintC);
                            paragraph && paragraph.layout(300);
                            const fo = hh > 600 ? 8 : 7;
                            paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);


                            surfRef.current.requestAnimationFrame(()=>{});
                        }
                        if (lns.length == 0 && test!=1) {

                            setTimeout(() => getObj(0, a.objet, 1), 100);
                            console.log('upl', a.objet)
                            objN.current = a.objet[a.objet.length - 1].id
                            setTimeout(() => surfRef.current.requestAnimationFrame(drawFrame), 10);
                            if (!sujet.current.video) {

                                const canvas_stream = htmlCanvasElement.current.captureStream(30); // fps
// Create media recorder from canvas stream
                                const options = {

                                    audioBitsPerSecond: 128000,
                                    videoBitsPerSecond: 2500000,
                                    mimeType: "video/webm;codecs=h264",
                                };
                                const options1 = {
                                    audioBitsPerSecond: 128000,
                                    videoBitsPerSecond: 2500000,
                                    mimeType: "video/mp4;codecs=avc1",
                                };
                                media_recorder.current = new MediaRecorder(canvas_stream, options);
// Record data in chunks array when data is available

// Provide recorded data when recording stops
                                media_recorder.current.onstop = () => {
                                    on_mr_stop(chunks);
                                }

// Start recording using a 1s timeslice [ie data is made available every 1s)
                                //
                                /****
                                 end
                                 */

                                //console.log(media_recorder.current.mimeType);
                            }
                        }
                    });

            });

        })

    }
    useEffect(() => {

        //createConnection().insert('objet',{sujet:878,delta:10000,deltaR:10000,start:0});
        function getSupportedMimeTypes(media, types, codecs) {
            const isSupported = MediaRecorder.isTypeSupported;
            const supported = [];
            types.forEach((type) => {
                const mimeType = `${media}/${type}`;
                codecs.forEach((codec) => [
                    `${mimeType};codecs=${codec}`,
                    `${mimeType};codecs=${codec.toUpperCase()}`,
                    // /!\ false positive /!\
                    // `${mimeType};codecs:${codec}`,
                    // `${mimeType};codecs:${codec.toUpperCase()}`
                ].forEach(variation => {
                    if (isSupported(variation))
                        supported.push(variation);
                }));
                if (isSupported(mimeType))
                    supported.push(mimeType);
            });
            return supported;
        };
        coeff = htmlCanvasElement.current && 1200 / htmlCanvasElement.current.getBoundingClientRect().height;

// Usage ------------------
        /*
           const videoTypes = ["webm", "ogg", "mp4", "x-matroska"];
           const audioTypes = ["webm", "ogg", "mp3", "x-matroska"];
           const codecs = ["should-not-be-supported","vp9", "vp9.0", "vp8", "vp8.0", "avc1", "av1", "h265", "h.265", "h264", "h.264", "opus", "pcm", "aac", "mpeg", "mp4a"];

           const supportedVideos = getSupportedMimeTypes("video", videoTypes, codecs);
           const supportedAudios = getSupportedMimeTypes("audio", audioTypes, codecs);

           console.log('-- Top supported Video : ', supportedVideos[0])
           console.log('-- Top supported Audio : ', supportedAudios[0])
           console.log('-- All supported Videos : ', supportedVideos)
           console.log('-- All supported Audios : ', supportedAudios)
          */


        Array(25).fill(1).map((c, i) => {
            const x = i % 5 - 2;
            const y = Math.floor(i / 5) - 2;
            const l = (3 - Math.sqrt(x * x + y * y)) / 3;
            // console.log("sum+=uImage.eval( vec2( pos.x+"+x+"*h, pos.y+"+y+"*h ) ) * "+l);


        })


        //const rootElement = document.getElementById("ttid");// ? document.getElementById("ttid") : document.getElementById("root");
        // rootElement.id='ttid';

        if (kit) {


        }
        return () => {
            console.log('destroy')
            //  draw.current=true;
            //htmlDivElement.current.remove();
            return;

        }
    }, [])
    const getDone = () => {
        return played.current;
    };
    const setSpeed = (s) => {
        speed.current = s;
    };
    const drw = (l) => {

        speed.current = speed.current;
        // surfRef.current.requestAnimationFrame(drawFrame);
    }
    const stopDraw = () => {
        //  setDrawS(1)

        dialog.current.style.display = 'none';
        player.current.style.display = 'block';
        suRef.current = surfRef.current.getCanvas();

        draw.current = false;
    };
    const startDraw = () => {
        //  setDrawS(1)
        if(line){
        console.log('start', totm + tm, line.id)
        stoppedLine.current = line.id;}
        dialog.current.style.display = 'block';
        player.current.style.display = 'none';
        suRef.current = surfRef.current.getCanvas();

        draw.current = true;
    };
    const log = useRef(null)
    const bounds = useRef(null)
    const startLine = useRef(null)
    const lineN = useRef(null);
    const linesN = useRef([]);
    const draww = useRef(null);
    const brush = useRef(localStorage.getItem('brush') ? localStorage.getItem('brush') : 'pen');
    const color = useRef(localStorage.getItem('color') ? new paper.Color(localStorage.getItem('color')) : '#666666');
    const sizeN = useRef(localStorage.getItem('size') ? localStorage.getItem('size') : 2);
    const stoppedLine = useRef(null);
    let coeff;
    const step = 3;
    const alpha = .9;
    const ptMove = (e) => {
        coeff = htmlCanvasElement.current && 1200 / htmlCanvasElement.current.getBoundingClientRect().width;


        if (draww.current) {
            const cco = bounds.current.width / ww;
//console.log('ptMove',e.clientX-bounds.current.x,coeff,coef,cco)
            // setPress(press + 1);
            const co = e.width == 0 ? e.pointerType === 'pen' ? 10 : 20 : e.pointerType === 'pen' ? 10 : 1;
            if (lineN.current) {

                lineN.current.points.push({
                    x: (e.clientX - bounds.current.x) / cco,
                    y: (e.clientY - bounds.current.y) / cco,
                    pressure: brush.current != 'pen' ? 0.01 : e.pressure * co,
                    pre: e.pressure * co,
                    ttm: 0,
                    tm: Date.now() - lineN.current.startT
                });

                //  console.log(brush.current);
                const pts = lineN.current.points.map(a => [a.x, a.y]);

                if (brush.current == 'flo') {

                    //  pts.push([lineN.current.points[0].x, lineN.current.points[0].y])

                }
                const lin = new paper.Path(pts);
                lin.closed = true;
                lineN.current.bounds = lin.strokeBounds;
                // lin.smooth({type: 'continuous'});
                lineN.current.lin = lin;
                lineN.current.pots = [];
                if (brush.current == 'flo') {


                    //  const dr = getSvgPathFromStroke(getStroke(lineN.current.points, lineN.current.opts));

                    // lineN.current.dr = dr;

                    //  const amount = 15;
                    //  const length = lin.length;
                    // console.log(Math.max(lin.strokeBounds.width,lin.strokeBounds.height));


                    //  lin.simplify(10);
                    // //console.log(lin.exportSVG({asString:true}).match(/d="([^"]+)"/)[1])
                    lineN.current.dr = lin.exportSVG({asString: true}).match(/d="([^"]+)"/)[1];

                } else {
                    lineN.current.dr = getSvgPathFromStroke(getStroke(lineN.current.points, lineN.current.opts));
                }

            }


        }
    }
    const handleUp = (e) => {


        if (draww.current) {
            draww.current = null;
            lineN.current.done = true;

            //const lns = lines.current.filter(a => !a.done);


            lineN.current.d = getSvgPathFromStroke(getStroke(lineN.current.points, lineN.current.opts));
            lineN.current.end = Date.now() - lineN.current.startT;
            lineN.current.endT = Date.now();
            linesN.current.push(lineN.current);


            linesN.current.map((a, i) => {
                const points = a.points.map(u => {

                    return [Math.floor(u.x * 1000) / 1000, Math.floor(u.y * 1000) / 1000, Math.floor(u.pressure * 100) / 100, u.tm]

                })
//console.log(points,JSON.stringify({col:a.color,s:a.size,b:a.brush,p:points}).length);
            })
            lineN.current = null;
            // console.log(paintA);return;
            /*
             */
            suRef.current.drawRRect(rrb, paintA);

            const im3 = surfRef.current.makeImageSnapshot([0, 0, ww, hh]);
            bgImage = im3.makeShaderOptions(
                ck.TileMode.Repeat,  // Tile the image in both X and Y directions
                ck.TileMode.Repeat,
                ck.FilterMode.Linear,
                ck.MipmapMode.Nearest,
                ck.Matrix.identity()
            );
            im3.delete();
            suRef.current.clear()
            if (shh) {
                const shn = shdFinal.makeShaderWithChildren(new Float32Array([ww, hh, ran]), [shh, paperB], matr);

                paintC.setShader(shn);
                suRef.current.drawRRect(rrb, paintC);
                paragraph && paragraph.layout(300);
                const fo = hh > 600 ? 8 : 7;
                paragraph && suRef.current.drawParagraph(paragraph, ww / 2 - 150, hh - fo * 6);
            }

            /*    //su.clear();
                //su.drawRRect(rrb, paintC);
                //  console.log('stopH');

             */
        }
    }
    const handleDown = (e) => {
        if (!draw.current) return;
        bounds.current = htmlCanvasElement.current.getBoundingClientRect()

        const tms = Date.now();
        //color.current = new paper.Color('#d500f9');
        const co = color.current;

        draww.current = true;
        //

        //paintC.setColor(new ck.Color4f(color.current.red, color.current.green, color.current.blue, alpha));
        const totSt = lines[0] ? lines[0].start : Date.now();
        const opts = new Opts(sizeN.current * 12, brush.current, e.pointerType == 'mouse');

        lineN.current = {
            points: [],
            ran: Math.random(),
            d: '',
            start: Date.now() - totSt,
            startT: Date.now(),
            opts: opts,
            alpha: .8,
            color: color.current.toCSS(false),
            size: sizeN.current,
            brush: brush.current,
            col: [co.red, co.green, co.blue, 0.8]

        };

        surfRef.current.requestAnimationFrame(drawFrameN);
    }
    const undo = () => {
    }
    const openP = () => {
    }
    const dias = (c, user) => {


        if (c) {
            const lns = (linesN.current.filter(c => c.points.length > 1));
            const tot = lns[lns.length - 1].endT - lns[0].start;

            const data = {
                user: user.id,
                name: 'temp',
                story: sujet.current.story,
                parent: sujet.current.id,
                startline: stoppedLine.current,
                totaltime: Math.floor(tot / 1000),
                size: sujet.current.size
            }

            const r = lns.map((a, i) => {
                return {
                    color: a.color, width: a.size, type: a.brush, line: '[]',
                    start: i, points: a.points.map(b => {
                        return {po: JSON.stringify([b.x, b.y, b.pressure])}
                    })
                }
            });
            console.log(r)

            createConnection().insert('sujet', data, 2).then(c => {

                createConnection().insert('objet', {sujet: c, start: 0, delta: 0, deltaR: 0}, 2).then(cc => {
                    const rr = r.map((a, i) => {
                        a.objet = cc;
                        return a;
                    })
                    createConnection().getnue({parent: cc, target: 'strokes', data: rr}, 'POST')
                        .then(
                            dd => {
                                //

                                dd.con.map((ddd, ig) => {
                                    if (r[ig]) {

                                        const f = r[ig]
                                        //console.log(f);
                                        if (f.points instanceof Array) {

                                            f.points.map(y => y.strokes = ddd)
                                            createConnection().getnue({
                                                target: 'point',
                                                data: f.points
                                            }, 'POST').then(ff => {


                                            })
                                        }
                                    }
                                })
                            }
                        )

                })
            })

        } else {
            linesN.current = [];

        }

    }
    const del = () => {

    }
    const blend = (a, o, size) => {

        const objP = a.objet
        const par = a.parent;
        startLine.current = a.startline;

        createConnection().getNew('strokes', 'order=start,asc&join=point&filter=objet,eq,' + objP[0].id).then(a => { //filter=id,lt,1366454&
            const recs = a.records.map((u, i) => {
                u.n = i;
                // u.color =  u.color.match(/^([0-9]+)$/) ? colors[Number[u.color ]] : u.color;
                if (u.point) {
                    u.line = u.point.filter(a => !a.pu && a).sort((a, b) => a.id - b.id).map(g => {
                        g = JSON.parse(g.po);
                        return {x: g[0], y: g[1], pressure: g[2]}
                    })


                } else {

                    u.line = u.line != '[]' ? JSON.parse(u.line) : JSON.parse(u.dots.replace(/{/g, '[').replace(/}/g, ']'));

                }

                let p;
                u.lineD = u.line.filter(h => {
                    let ret = false;
                    if (!p) ret = true; else {
                        if (h.x) {
                            if (p.x != h.x && p.y != h.y) ret = true;


                        } else {
                            if (p[0] != h[0] && p[1] != h[1]) ret = true;


                        }
                    }
                    p = h;

                    return ret ? h : null;

                }).map(h => {
//console.log(h)
                    return !h.x ? {
                        x: (h[0] + size[2]) * coef,
                        y: (h[1] + size[3]) * coef,
                        pressure: h[2] * sca
                    } : {x: h.x * coef + size[2] * coef, y: h.y * coef + size[3] * coef, pressure: h.pressure * sca};

                });

//u.opts=new Opts(u.size ? u.size:1,u.type);


                //   const opts = new Opts(u.width ? 0.4 * u.width : 0.2, u.type,obj[ob].pointer);
                //  const opts = new Opts(t.width ? t.width : 4, t.type);

                // u.opts = opts;

                u.opts = {
                    size: u.width ? 0.02 * u.width : 0.2,
                    thinning: 1,
                    simulatePressure: false
                }
                //  u.opts =new Opts(u.width ? 0.4 * u.width : 0.2, u.type,obj[ob].pointer ? obj[ob].pointer : false);
                //console.log(u.type,u.opts);
                if (!u.delta || u.delta > 1000) {
                    const ln = new paper.Path(u.lineD.map(a => [a.x, a.y]));
                    u.delta = ln.length;
                }
                let col;
                u.d = getSvgPathFromStroke(getStroke(u.lineD, u.opts));
                if (u.color.match('#')) {

                    const co = new paper.Color(u.color);

                    u.color = new ck.Color4f(co.red, co.green, co.blue, 0.8);
                    u.col = [co.red, co.green, co.blue, 0.8];
                    u.colCSS = co.toString(true);
                } else {
                    const co = new paper.Color(u.color);
                    u.colCSS = co.toString(true);
                    u.color = u.color.match(' ') ? u.color.replace(/ /g, '') : u.color

                    col = u.color.match(/([\d|,|\.]+)/) ? u.color.match(/([\d|,|\.]+)/)[0].split(',') : [0, 0, 0, 1];


                    col.length == 3 && col.push(0.8);
                    u.color = new ck.Color(col[0], col[1], col[2], col[3]);

                    const colC = Math.max(col[0], col[1], col[2]) > Math.min(col[0], col[1], col[2]) * 1.2 ? 0.8 : 1;
                    u.col = col.map((c, i) => i < 3 ? Number(c) / 255 : Number(c) * colC);
                }
//console.log(u.col);
                const paint2 = new ck.Paint();
                paint2.setColor(u.color);
                paint2.setStyle(ck.PaintStyle.Fill);
                paint2.setAntiAlias(true);

                u.paint = paint2;
                linesExtra.push(u);


                //if (u.id == 10729) console.log(u.d, u.lineD, u.line);
                return u;

            });


        });

        funca(o, par)
    }
    const funca = (o, idd = id) => {
        const canvasRes = htmlCanvasElement.current ? htmlCanvasElement.current : o.current;
//const  htmlDivElement = document.createElement("div");
        if( document.getElementById('ttid') )document.getElementById('ttid').id="d";

        if (!canvasRes) return;
        if (!sujet.current) {


            createConnection().getNew('sujet/' + idd, 'join=objet,strokes&include=objet.transforms,thumb,story,name,size,totaltime,parent,startline,strokes.id,image,video').then(a => {
                    size = a.size.split(',').map(c => Number(c)).concat([0, 0]);


                    if (a.parent > 0) return blend(a, o, size)
                    sujet.current = a;
                    const w0 = Number(size[0]);
                    const h0 = Number(size[1]);
                    let w = w0;
                    let h = h0;

                    const sizeCoef = (caseUse == 'sticker' || Math.abs((w - h) / h) < 0.2) ? 1 : 9 / 16;
                    if (h0 > w0) {
                        if (h0 / w0 > 1 / sizeCoef) {
                            w = h0 * sizeCoef;

                        } else {

                            h = w0 / sizeCoef;


                        }

                    } else {
                        if (h0 / w0 > sizeCoef) {
                            w = h0 / sizeCoef;

                        } else {

                            h = w0 * sizeCoef;

                        }


                    }

                    const totL = a.totaltime;

                    if (h0 > w0) {


                        if (hi / wi >= h / w) {

                            coef = (wi / w);
                            hhR = (hi / wi * w - h) / 2;
                        } else {

                            coef = hi / h;
                        }
                    } else {

                        if (hi / wi >= h / w) {

                            coef = (wi / w);
                            hhR = (hi / wi * w - h) / 2;
                        } else {

                            coef = hi / h;
                        }


                    }

                    coef = coef * sca;
                    hh = h * coef;
                    ww = w * coef;


                    //////////
                    // Default typeface, font size 40
                    const maxSide = caseUse == 'sticker' ? 512 : 1200;
                    const d = caseUse == 'sticker' ? maxSide / ww : maxSide / Math.min(maxSide, Math.max(ww, hh));

//rootElement.classList.add("hv100");//'hv100';
//document.getElementById('ttid') && document.querySelector("#ttid > div > div").className = "relative";
                    ww = Math.round(ww * d);

                    coef = coef * d;
                    hh = Math.round(hh * d);

                    canvasRes.width = ww;
                    canvasRes.height = hh;
                    if (debug) {

                        document.getElementById('debug').style.height = '100%'
                        paper.setup(document.getElementById('debug'));
                        document.getElementById('debug').width = ww;
                        document.getElementById('debug').height = hh;
                        document.getElementById('debug').style.height = '100%'
                        document.getElementById('debug').style.width = '100%'
                        paper.project.activeLayer.addChild(new paper.Path());
                    }
                    const coe = ww / hh;

                    // htmlDivElement.current.style.width = coe < 1 ? '96%' : '100%';


                    htmlDivElement.current.style.aspectRatio = coe + '/1';

                    if (coe == 1) {
                        //htmlDivElement.style.width= hi>wi ? '90%' : "auto";
                        // htmlDivElement.style.height= hi>wi ? "auto"  : '90%';

                    } else {
                        //  htmlDivElement.style.width=hh>ww ? 'auto' : hh==ww ? hi>wi ? 'auto' : '90%' : "auto";
                        //  htmlDivElement.style.height=hh>ww ? '90%' : hh==ww ? hi>wi ?  '90%' : 'auto' : "90%";

                    }


                    upl(a, ww, hh);

                    // !dia && setDia({coef: coef, size: size, ww: ww, hh: hh});
                    // su1.drawRRect(rrb, paint2);


                }
            );

        }
    }
    return (
        <>
            <div className='hv100'>

                <div style={{margin: 'auto'}}>

                    {kit && (
                        <div className="relative" ref={htmlDivElement} onPointerMove={(e) => ptMove(e)}
                             onPointerDown={e => handleDown(e)}
                             onPointerUp={(e) => handleUp(e)}
                             onPointerLeave={(e) => handleUp(e)}>

                            <Canv f={funca} h={htmlCanvasElement} su={sujet.current}/>
                            {debug && (
                                <div className={'absolute top-0 left-0 w-full h-full'} style={{pointerEvents: 'none'}}>

                                    <div
                                        className={'bg-black text-white px-2 d-flex  absolute top-0 left-0  w-full justify-between '}>
                                        <small ref={log}></small><ZoomInOutlined fontSize="small" color="white"/>
                                    </div>
                                    <canvas id='debug'></canvas>
                                </div>
                            )}
                        </div>

                    )}

                    {kit && (
                        <div className="flex" style={{marginTop: '-32px', justifyContent: 'end'}}>

                            <div style={{width: '280px', display: 'none'}} ref={dialog}>

                                <DialogP
                                    lines={linesN.current} undo={undo} dias={dias} del={del}
                                    pr={openP} size={sizeN.current} color={color.current} brush={brush.current}
                                    stopDraw={stopDraw}
                                    fub={fub}/>

                            </div>


                            <div ref={player} style={{width: '280px', display: 'block'}}>
                                <Player foo={setSpeed} su={() => sujet.current} p={replay} done={getDone}
                                        startDraw={startDraw}/>

                            </div>


                        </div>
                    )}
                </div>

            </div>
            <button onClick={() => redraw(0)}>redraw</button>
            <button onClick={() => clear()}>clear</button>
        </>

    )
}
const Canv = memo(function Canv({f, h, su}) {

    useEffect(() => {


        if (!su) f(h)
    })
    return <canvas id="foo" ref={h}/>

})